import React, { useReducer, useMemo } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/react-hooks'

import { AUTH_CONFIG } from './config/auth0.config'
import Auth0Provider from './auth'
import { Initial_State, Global_Reducer, Context } from './shared/store/reducers/global-reducer'
import AppLayout from './layouts'
import AppRoutes from './routes'
import './App.scss'
import { AwsCredentialsProvider } from './routes/plus/context/AWS-credentials.context'
import { getConfig } from './config/runtime'

const onRedirectCallback = (appState: any) => {
  const targetUrl = appState?.targetUrl || window.location.pathname
  if (targetUrl !== window.location.pathname) {
    window.location.replace(targetUrl)
  }
  window.history.replaceState({}, document.title, targetUrl)
}

const App = (props: any) => {
  const [store, dispatch] = useReducer(Global_Reducer, Initial_State)

  const apolloClient = useMemo(
    () => new ApolloClient({ uri: getConfig().pag.graphqlUrl, cache: new InMemoryCache() }),
    []
  )

  return (
    <Auth0Provider
      domain={AUTH_CONFIG.domain}
      client_id={AUTH_CONFIG.client_id}
      redirect_uri={window.location.origin}
      audience={AUTH_CONFIG.audience}
      returnTo={AUTH_CONFIG.returnTo}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      onRedirectCallback={onRedirectCallback}
    >
      <ApolloProvider client={apolloClient}>
        <Context.Provider value={{ store, dispatch }}>
          <AwsCredentialsProvider>
            <BrowserRouter>
              <AppLayout>
                <AppRoutes />
              </AppLayout>
            </BrowserRouter>
          </AwsCredentialsProvider>
        </Context.Provider>
      </ApolloProvider>
    </Auth0Provider>
  )
}

export default App
